import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { ProgressCircleWebElement } from './ProgressCircleWebElement';
export { ProgressCircleWebElement };

/**
 * Retrieve an instance of [ProgressCircleWebElement](../classes/ProgressCircleWebElement.html).
 * @example
 * ```javascript
 * import { findProgressCircle } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findProgressCircle(driver, By.id('my-oj-c-progress-circle'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findProgressCircle(
  driver: DriverLike,
  by: By
): Promise<ProgressCircleWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type ProgressCircleWebElement
  if (!(webEl instanceof ProgressCircleWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'ProgressCircleWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findProgressCircle(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${ProgressCircleWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-progress-circle', ProgressCircleWebElement);
